import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import TabelHeader from './components/TabelHeader.vue';
import EditTable from './components/EditTable.vue';
import TabelToolBar from './components/TabelToolBar';
import { ExportPartDetailData } from '@/api/DnbarcodeHandmade';
import util from '@/libs/util';
import ExportListMixin from '@/views/mixin/ExportList';
export default {
  mixins: [ExportListMixin],
  components: {
    TabelHeader: TabelHeader,
    EditTable: EditTable,
    TabelToolBar: TabelToolBar
  },
  data: function data() {
    return {
      isShowTabelHeader: false,
      TabelHeaderData: null,
      tableData: [],
      MST_ID: null
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/DnbarcodeHandmade', ['setOrderStatu'])), {}, {
    // 物料明细导出
    onHandleExportPartDetail: function onHandleExportPartDetail() {
      var params = {
        BARCODE_TYPE: 1,
        ORGANIZE_ID: util.cookies.get('ORG_ID'),
        MST_ID: this.$refs.TabelHeader.getData().ID,
        EXPORT_FILE_NAME: '手工内箱物料明细'
      };
      this.$message.success('已添加到 导出列表 中');
      this.setUnreadExportMessionNum();
      ExportPartDetailData(params); // if (res.code === 0) {
      //   window.open(this.$store.getters.getVUE_APP_DOWN + res.data)
      // } else {
      //   this.$message.warning('数据导出失败----' + res.message)
      // }
    },
    // cb切换单据
    cbNextOrder: function cbNextOrder(info, STATUS) {
      // console.log('info', info)
      // console.log('STATUS', STATUS)
      this.onSaveID = info.ID;
      this.$refs.EditTable.setListData(info);
      this.$refs.EditTable.GetDnbarcodeDtlList();
      this.$refs.TabelToolBar.setStatus(STATUS);
    },
    // 上一张
    getBackOrder: function getBackOrder() {
      this.$refs.TabelHeader.getBackUpdata();
    },
    // 下一张
    nextOrder: function nextOrder() {
      this.$refs.TabelHeader.nextOrderUpdata();
    },
    // 条码明细导出
    onHandleExportPartBarcode: function onHandleExportPartBarcode() {
      this.$refs.TabelHeader.ExportPartBarcodeData();
    },
    // 点击取消
    onHandleCancelBtn: function onHandleCancelBtn() {
      var _this = this;

      this.$confirm('返回不会保存已修改的明细, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$setOrderStatu('orderShow');

        _this.$refs.TabelHeader.updataInfo(); // this.$emit('handleBlackBtn')

      }).catch(function () {
        _this.$message.warning('已取消');
      });
    },
    // 保存成功
    saveSuccess: function saveSuccess(MST_ID) {
      this.MST_ID = MST_ID;

      if (this.$DnbarcodeHandmadeState === 'addOrder') {
        this.$setOrderStatu('orderShow');
        this.$refs.TabelHeader.setID(MST_ID);
      } else if (this.$DnbarcodeHandmadeState === 'editOrder') {
        this.$setOrderStatu('orderShow');
        this.$refs.TabelHeader.updataInfo();
        this.$refs.EditTable.GetDnbarcodeDtlList();
      }
    },
    // 点击修改
    handleEdit: function handleEdit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vali;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$refs.EditTable.valiHasPartBarcode();

              case 2:
                vali = _context.sent;

                if (vali === true) {
                  _this2.$message.warning('已生成条码，不能修改');
                } else {
                  _this2.setOrderStatu('editOrder');
                } // if(this.TabelHeaderData.STATUS === 2){
                //     this.$message.warning('已生成条码，不能修改')
                //     return
                // }else{
                //     this.setOrderStatu('editOrder')
                // }


              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 点击返回
    handleBlackBtn: function handleBlackBtn() {
      var _this3 = this;

      this.$emit('handleBlackBtn');
      this.$nextTick(function () {
        _this3.$refs.EditTable.resetCurrentPane();
      });
    },
    // 表格数据
    cbTabelData: function cbTabelData(value) {
      this.tableData = value;
    },
    // 点击单号打印
    handleRowPrint: function handleRowPrint(row) {
      this.$refs.TabelHeader.PrintRowOuterBoxLabel(row);
    },
    // 组合打印内箱标签
    onHandlePrintParBarcodeGroup: function onHandlePrintParBarcodeGroup() {
      this.$refs.TabelHeader.PrintParBarcodeGroup();
    },
    // 生成标签
    handleCreatePartBarcode: function handleCreatePartBarcode() {
      this.$refs.EditTable.handleCreatePartBarcode(this.$refs.TabelHeader.getData());
    },
    // 设置数据
    setData: function setData(data) {
      var _this4 = this;

      console.log('设置数据', data);
      this.TabelHeaderData = data;
      this.$nextTick(function () {
        _this4.$refs.TabelHeader.setFormData(data); // 设置表头数据


        _this4.$refs.EditTable.setListData(data); // 设置明细数据

      });
    },
    // 选择物料
    onSelectMaterial: function onSelectMaterial() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.$refs.TabelHeader.valiVendorName();

              case 2:
                res = _context2.sent;

                if (res.vali === true) {
                  _this5.$refs.EditTable.ShowChangeMaterialDialog(res.VENDOR_CODE, _this5.tableData);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 保存
    onSave: function onSave() {
      this.$refs.EditTable.saveData(this.$refs.TabelHeader.getData());
    }
  }),
  watch: {
    $DnbarcodeHandmadeState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.TabelHeaderData = null;
          this.isShowTabelHeader = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.TabelHeaderData = null;
          this.isShowTabelHeader = true;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowTabelHeader = true;
        } else if (nawValue === 'editOrder') {}
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DnbarcodeHandmadeState']))
};